import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { makeGridGetRowsResponse } from '@cbridge-tools/default-data-grid';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolLpAction } from '../symbolLp.action';
import { LpSymbolsFilter } from '../symbolLp.interface';
import { SymbolLpTranslator } from '../symbolLp.translator';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolLpListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.loadList.started),
  mergeMap((params) => {
    const { resolve, reject, ...payload } = params;

    return dependencies.api.getLpSymbolList(SymbolLpTranslator.toApiPayload(payload)).pipe(
      mergeMap((response) => {
        const { lpSymbols, totalCount, filteredCount, unmappedCount } = response;

        const items = lpSymbols.map(SymbolLpTranslator.fromApi);
        const rowCount = payload.filter === LpSymbolsFilter.Unmapped
          ? filteredCount + unmappedCount
          : filteredCount;
        resolve?.(makeGridGetRowsResponse(items, rowCount));

        return [
          SymbolLpAction.loadList.done({ params, result: { items, totalCount, filteredCount, unmappedCount } }),
        ];
      }),
      catchApiError((error) => {
        // a rejected getRows promise leaves the grid in skeleton state forever;
        // settle it with an empty page so the failure overlay can render
        resolve?.(makeGridGetRowsResponse([], 0));
        return [
          SymbolLpAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
